import { createAsyncThunk } from '@reduxjs/toolkit';
import { verify_user, top_user_service } from '../services/userVerifyServices';

export const userVerify = createAsyncThunk(
    'verify/user',
    async ({ code, deviceToken }, { rejectWithValue }) => {
        try {
            const data = await verify_user(code, deviceToken);
            localStorage.setItem('access_token', data.access_token);
            localStorage.setItem('role', data.role);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка идентификации';
            return rejectWithValue(errorMessage);
        }
    }
);


export const fetchTopUsers = createAsyncThunk(
    'topUsers/fetch',
    async (deviceToken, { rejectWithValue }) => {
        try {
            const data = await top_user_service(deviceToken);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка получения топ-пользователей';
            return rejectWithValue(errorMessage);
        }
    }
);
